/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as Bar3DLayerSpec } from '../../../../layer/preset/bar/bar3D';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

type Bar3DLayerType = StandardChartLayerSpec & Bar3DLayerSpec & ILayerTypeSpec;

// 创建3D柱状图数据类型验证器
const validateBar3DDataTypes = createDataTypeValidator('bar3D', [
  { field: 'x', type: 'string' },
  { field: 'y', type: ['string', 'date'] },
  { field: 'z', type: 'number' }
]);

// 创建3D柱状图编码验证器
const validateBar3DEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y' },
  { field: 'z' }
]);

// 额外的检查函数
const additionalBar3DChecks = (layer: Bar3DLayerType) => {
  const { encoding } = layer;
  if (encoding.x && encoding.y && encoding.z) {
    utils.logger.info(
      'info',
      'For better 3D visualization, ensure data points form a complete grid in x-y plane'
    );
  }
};

// 创建并导出3D柱状图处理器
export const bar3D = createLayerProcessor<Bar3DLayerType>(
  'bar3D',
  validateBar3DEncoding,
  validateBar3DDataTypes,
  additionalBar3DChecks
);
